import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Grid,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Checkbox,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Badge,
  Avatar,
  TablePagination
} from '@material-ui/core';
import {
  DeleteOutlined,
  GetApp,
  Search,
  TrendingUp,
  AttachMoney,
  ShoppingCart,
  Person,
  LocationOn,
  PictureAsPdf,
  DateRange,
  SearchOutlined,
  Visibility,
  Payment,
  EuroSymbol,
  Percent,
  LocalAtm,
  Smartphone,
  AccountBalance,
  CreditCard,
  CalendarToday,
  PersonOutline
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from "react-toastify";

import CustomizedDialogs from '../dialog';
import BonClientService from '../../services/BonClientService';
import ClientService from '../../services/ClientService';
import TypeClientService from '../../services/TypeClientService';
import PayeBon from '../PayeBon';
import PayementForm from '../PayementForm';
import generatePDFBon from '../../utils/factureUtils';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#f8fafc',
    minHeight: '100vh',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  title: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
    fontSize: '2.5rem',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  subtitle: {
    color: '#6c757d',
    fontSize: '1.1rem',
  },
  filterCard: {
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(34, 109, 104, 0.08)',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    background: 'white',
    border: '1px solid #e2e8f0',
  },
  tableCard: {
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(34, 109, 104, 0.08)',
    overflow: 'hidden',
    background: 'white',
    border: '1px solid #e2e8f0',
  },
  statsCard: {
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(34, 109, 104, 0.08)',
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    background: 'white',
    border: '1px solid #e2e8f0',
  },
  formControl: {
    minWidth: 200,
    marginRight: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      '&:hover fieldset': {
        borderColor: '#226D68',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#226D68',
        borderWidth: '2px',
      },
    },
  },
  searchButton: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    fontWeight: 600,
    padding: '12px 24px',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #1a5a55 0%, #22746d 100%)',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 24px rgba(34, 109, 104, 0.4)',
    },
    transition: 'all 0.3s ease',
  },
  exportButton: {
    background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
    color: 'white',
    fontWeight: 600,
    padding: '12px 24px',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(242, 101, 34, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #e55a1a 0%, #ff7b2e 100%)',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 24px rgba(242, 101, 34, 0.4)',
    },
    transition: 'all 0.3s ease',
  },
  modernTable: {
    '& .MuiTableHead-root': {
      backgroundColor: '#226D68',
      '& .MuiTableCell-head': {
        color: 'white',
        fontWeight: 600,
        fontSize: '0.85rem',
        borderBottom: 'none',
        padding: '12px 16px',
      },
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        //backgroundColor: '#f8f9fa',
      },
      '&.selected-row': {
        backgroundColor: '#e8f4f3',
      },
    },
    '& .MuiTableCell-body': {
      fontSize: '0.875rem',
      borderBottom: '1px solid #e2e8f0',
      padding: '12px 16px',
    },
  },
  statusBadge: {
    '& .MuiBadge-badge': {
      fontSize: '0.7rem',
      height: 20,
      minWidth: 20,
      borderRadius: 10,
    },
    '& .paid': {
      backgroundColor: '#28a745',
    },
    '& .unpaid': {
      backgroundColor: '#dc3545',
    },
  },
  actionButton: {
    margin: theme.spacing(0.5),
    minWidth: 36,
    height: 36,
    borderRadius: 8,
    '&.pay-button': {
      background: 'linear-gradient(135deg, #28a745 0%, #34ce57 100%)',
      color: 'white',
      '&:hover': {
        background: 'linear-gradient(135deg, #218838 0%, #2db34a 100%)',
      },
    },
    '&.pdf-button': {
      background: 'linear-gradient(135deg, #d32f2f 0%, #f44336 100%)',
      color: 'white',
      '&:hover': {
        background: 'linear-gradient(135deg, #c62828 0%, #e53935 100%)',
      },
    },
    '&.delete-button': {
      background: 'linear-gradient(135deg, #6c757d 0%, #868e96 100%)',
      color: 'white',
      '&:hover': {
        background: 'linear-gradient(135deg, #5a6268 0%, #727b84 100%)',
      },
    },
  },
  tvaChip: {
    fontSize: '0.75rem',
    fontWeight: 600,
    '&.tva-1': {
      backgroundColor: 'rgba(40, 167, 69, 0.1)',
      color: '#28a745',
      border: '1px solid rgba(40, 167, 69, 0.3)',
    },
    '&.tva-05': {
      backgroundColor: 'rgba(23, 162, 184, 0.1)',
      color: '#17a2b8',
      border: '1px solid rgba(23, 162, 184, 0.3)',
    },
    '&.tva-0': {
      backgroundColor: 'rgba(108, 117, 125, 0.1)',
      color: '#6c757d',
      border: '1px solid rgba(108, 117, 125, 0.3)',
    },
  },
  amountCell: {
    fontWeight: 600,
    fontFamily: "'Roboto Mono', monospace",
    '&.ht': {
      color: '#226D68',
    },
    '&.tva': {
      color: '#f26522',
    },
    '&.ttc': {
      color: '#28a745',
    },
  },
  clientAvatar: {
    width: 32,
    height: 32,
    fontSize: '0.875rem',
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
  },
  dateCell: {
    fontSize: '0.8rem',
    color: '#6c757d',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  infoContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  statChip: {
    fontWeight: 600,
    fontSize: '0.9rem',
    '&.total': {
      background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
      color: 'white',
    },
    '&.amount': {
      background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
      color: 'white',
    },
    '&.client': {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
    },
    '&.ipm': {
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      color: 'white',
    },
  },
  dateFilterContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  tabContainer: {
    marginBottom: theme.spacing(3),
  },
  tab: {
    minWidth: 120,
    '&.Mui-selected': {
      color: '#226D68',
      fontWeight: 600,
    },
  },
  periodSearchInfo: {
    backgroundColor: '#e8f4f3',
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

const ListBonClient = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [data, setData] = useState([]);
  const [type, setType] = useState([]);
  const [filters, setFilters] = useState([]);
  const [idClient, setIdClient] = useState(null);
  const [sort, setSort] = useState("NON_PAYER");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchMode, setSearchMode] = useState('client');
  const [clientInfo, setClientInfo] = useState(null);
  const [periodSearch, setPeriodSearch] = useState({
    startDate: '',
    endDate: '',
    idClient: '',
    statut: ''
  });
  const [dateFilter, setDateFilter] = useState({
    startDate: '',
    endDate: ''
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Fonction pour normaliser les données
  const normalizeData = (data) => {
    if (!Array.isArray(data)) return [];
    
    return data.map(item => {
      if (item.idProdVdu && !item.idBon) {
        return {
          idBon: item.idProdVdu,
          idProdVdu: item.idProdVdu,
          beneficiaire: item.beneficiaire || item.nom || '',
          qtVdu: item.qtVdu,
          nomProd: item.nomProd,
          prixProdVendu: item.prixProdVendu,
          total: item.total,
          total_remise: item.remise || item.total_remise || 0,
          dateEnreg: item.dateInsert || item.dateEnreg,
          statut: item.etat === 'VENDU' ? 'PAYER' : (item.statut || 'NON_PAYER'),
          idClient: item.idClient,
          nom: item.nom,
          adresse: item.adresse,
          total_client: item.total_client,
          total_ipm: item.total_ipm,
          designation: item.designation,
          codeIdProd: item.codeIdProd,
          prix_sans_tva: item.prix_sans_tva || item.total || (item.prixProdVendu * item.qtVdu),
          prix_avec_tva: item.prix_avec_tva || item.total,
          tva_montant: item.tva_montant || 0,
          tva_taux: item.tva_taux || 0
        };
      }
      return {
        ...item,
        prix_sans_tva: item.prix_sans_tva || item.total,
        prix_avec_tva: item.prix_avec_tva || item.total,
        tva_montant: item.tva_montant || 0,
        tva_taux: item.tva_taux || 0
      };
    });
  };

  const handleDelete = async (rowData) => {
    const idToDelete = rowData.idBon || rowData.idProdVdu;
    
    if (!idToDelete) {
      toast.error("Impossible de supprimer : ID manquant", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    
    await BonClientService.annulerBon(idToDelete)
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        refreshBons();
        setSelectedRows(prev => prev.filter(rowId => rowId !== idToDelete));
      })
      .catch((error) => {
        console.log(error);
        toast.error("Erreur lors de la suppression", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  const handleSinglePDF = (rowData) => {
    try {
      let clientInfo;
      if (searchMode === 'client' && idClient) {
        clientInfo = filters.find(client => client.idClient === idClient);
      } else if (searchMode === 'period' && periodSearch.idClient) {
        clientInfo = filters.find(client => client.idClient === periodSearch.idClient);
      } else if (rowData.idClient) {
        clientInfo = filters.find(client => client.idClient === rowData.idClient);
      }
      const fileName = generatePDFBon([rowData], clientInfo);
      
      toast.success(`Facture "${fileName}" générée avec succès`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      toast.error("Erreur lors de la génération de la facture", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  // Fonction pour la recherche par période
  const handlePeriodSearch = async () => {
    if (!periodSearch.startDate || !periodSearch.endDate) {
      toast.warning("Veuillez sélectionner une période", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    const start = new Date(periodSearch.startDate);
    const end = new Date(periodSearch.endDate);
    if (start > end) {
      toast.warning("La date de début doit être antérieure à la date de fin", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    setLoading(true);
    try {
      const { startDate, endDate, idClient, statut } = periodSearch;
      
      const response = await BonClientService.searchBonClientByPeriod(
        startDate, 
        endDate, 
        idClient || null, 
        statut || null
      );
      
      const normalizedData = normalizeData(response.data);
      setData(normalizedData);
      setSelectedRows([]);
      
      if (statut) {
        setSort(statut);
      }
      
      toast.success(`${normalizedData.length} bons trouvés`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.log(error);
      toast.error("Erreur lors de la recherche", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMultiplePDF = () => {
    if (selectedRows.length === 0) {
      toast.warning("Veuillez sélectionner au moins un bon", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    try {
      let clientInfo;
      if (searchMode === 'client' && idClient) {
        clientInfo = filters.find(client => client.idClient === idClient);
      } else if (searchMode === 'period' && periodSearch.idClient) {
        clientInfo = filters.find(client => client.idClient === periodSearch.idClient);
      }
      const selectedData = data.filter(row => selectedRows.includes(row.idBon));
      const fileName = generatePDFBon(selectedData, clientInfo);
      
      toast.success(`Facture "${fileName}" générée avec succès (${selectedRows.length} bons)`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      toast.error("Erreur lors de la génération de la facture", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const handleExportPDF = () => {
    if (data.length === 0) {
      toast.warning("Aucune donnée à exporter", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
  
    try {
      let clientInfo;
      if (searchMode === 'client' && idClient) {
        clientInfo = filters.find(client => client.idClient === idClient);
      } else if (searchMode === 'period' && periodSearch.idClient) {
        clientInfo = filters.find(client => client.idClient === periodSearch.idClient);
      }
      const fileName = generatePDFBon(data, clientInfo);
      
      toast.success(`Facture "${fileName}" générée avec succès`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      toast.error("Erreur lors de la génération de la facture", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  // Fonction pour appliquer le filtre par date
  const applyDateFilter = (bons) => {
    if (!dateFilter.startDate && !dateFilter.endDate) {
      return bons;
    }

    return bons.filter(bon => {
      const bonDate = new Date(bon.dateEnreg || bon.dateInsert);
      let passFilter = true;

      if (dateFilter.startDate) {
        const startDate = new Date(dateFilter.startDate);
        startDate.setHours(0, 0, 0, 0);
        passFilter = passFilter && bonDate >= startDate;
      }

      if (dateFilter.endDate) {
        const endDate = new Date(dateFilter.endDate);
        endDate.setHours(23, 59, 59, 999);
        passFilter = passFilter && bonDate <= endDate;
      }

      return passFilter;
    });
  };

  // Fonction pour réinitialiser le filtre date
  const resetDateFilter = () => {
    setDateFilter({
      startDate: '',
      endDate: ''
    });
  };

  // Fonction pour réinitialiser la recherche
  const resetSearch = () => {
    setData([]);
    setSelectedRows([]);
    setIdClient(null);
    setSort("NON_PAYER");
    setPeriodSearch({
      startDate: '',
      endDate: '',
      idClient: '',
      statut: ''
    });
    setDateFilter({
      startDate: '',
      endDate: ''
    });
  };

  const handleStatut = async (e) => {
    const newStatut = e.target.value;
    setSort(newStatut);
    if (idClient) {
      setLoading(true);
      try {
        const response = await BonClientService.getBonClientByStatut(idClient, newStatut);
        const normalizedData = normalizeData(response.data);
        setData(normalizedData);
        setSelectedRows([]);
        await refreshClientInfo();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleFilters = async (e) => {
    const value = e.target.value;
    setLoading(true);
    try {
      const response = await ClientService.getTypeClient(value);
      setFilters(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const initialValues = {
    idClient: '',
  };

  const validationSchema = Yup.object().shape({
    idClient: Yup.number().required("Le client est requis"),
  });

  const onSubmit = async (values, props) => {
    setLoading(true);
    try {
      setIdClient(values.idClient);
      const response = await BonClientService.getBonByClient(values.idClient);
      const normalizedData = normalizeData(response.data);
      setData(normalizedData);
      setSelectedRows([]);
      toast.success(`${normalizedData.length} bons trouvés`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.log(error);
      toast.error("Erreur lors de la recherche", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour rafraîchir les infos client
  const refreshClientInfo = async () => {
    if (idClient) {
      try {
        const clientResponse = await ClientService.getClientById(idClient);
        if (clientResponse.data && clientResponse.data.length > 0) {
          setClientInfo(clientResponse.data[0]);
        }
      } catch (error) {
        console.error("Erreur rafraîchissement client:", error);
      }
    }
  };

  const refreshBons = async () => {
    if (searchMode === 'client' && idClient) {
      setLoading(true);
      try {
        const response = await BonClientService.getBonByClient(idClient);
        const normalizedData = normalizeData(response.data);
        setData(normalizedData);
        setSelectedRows([]);
        await refreshClientInfo();
      } catch (error) {
        console.log(error);
        toast.error("Erreur lors du rafraîchissement", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } finally {
        setLoading(false);
      }
    } else if (searchMode === 'period') {
      handlePeriodSearch();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await TypeClientService.getTypeClient();
        setType(response.data);
      } catch (error) {
        console.log(error);
        toast.error("Erreur lors du chargement des types de client", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredData = applyDateFilter(data);
  const totalAmount = filteredData.reduce((a, v) => a + (v.total || 0), 0);
  const totalClient = filteredData.reduce((a, v) => a + (v.total_client || 0), 0);
  const totalIpm = filteredData.reduce((a, v) => a + (v.total_ipm || 0), 0);
  const totalTVA = filteredData.reduce((a, v) => a + (v.tva_montant || 0), 0);
  const totalTTC = filteredData.reduce((a, v) => a + (v.prix_avec_tva || v.total || 0), 0);
  
  // Déterminer le client sélectionné
  let selectedClient = null;
  if (searchMode === 'client' && idClient) {
    selectedClient = clientInfo || filters.find(client => client.idClient === idClient);
  } else if (searchMode === 'period' && periodSearch.idClient) {
    selectedClient = filters.find(client => client.idClient === periodSearch.idClient);
  }
  
  const isIPMType = selectedClient?.designation?.toUpperCase() === "IPM RIDWAN";

  // Fonction pour déterminer l'icône du mode de paiement selon le taux TVA
  const getPaymentIcon = (tvaTaux) => {
    switch (tvaTaux) {
      case 0.01: // Espèces
        return <LocalAtm fontSize="small" />;
      case 0.005: // Mobile Money
        return <Smartphone fontSize="small" />;
      case 0: // Chèque/Carte
        return <AccountBalance fontSize="small" />;
      default:
        return <EuroSymbol fontSize="small" />;
    }
  };

  // Gestion de la pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Données paginées
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
      
        {/* Sélection du mode de recherche */}
        <Box className={classes.tabContainer}>
          <Tabs
            value={searchMode}
            onChange={(e, newValue) => {
              setSearchMode(newValue);
              resetSearch();
            }}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab 
              label="Par Client" 
              value="client" 
              className={classes.tab}
              icon={<Search />}
            />
            <Tab 
              label="Par Période" 
              value="period" 
              className={classes.tab}
              icon={<DateRange />}
            />
          </Tabs>
        </Box>

        {/* Recherche par Client */}
        {searchMode === 'client' && (
          <Card className={classes.filterCard}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <Search style={{ marginRight: 8, color: '#226D68' }} />
                <Typography variant="h5" style={{ color: '#226D68', fontWeight: 600 }}>
                  Recherche par Client
                </Typography>
              </Box>

              <Formik 
                initialValues={initialValues} 
                validationSchema={validationSchema} 
                onSubmit={onSubmit}
              >
                {(props) => (
                  <Form>
                    <Grid container spacing={3} alignItems="center">
                      {/* Type Client */}
                      <Grid item xs={12} md={3}>
                        <FormControl variant="outlined" className={classes.formControl} fullWidth>
                          <InputLabel>Type Client</InputLabel>
                          <Select
                            label="Type Client"
                            onChange={handleFilters}
                            disabled={loading}
                          >
                            <MenuItem value="">
                              <em>Tous les types</em>
                            </MenuItem>
                            {type.map((typeItem) => (
                              <MenuItem key={typeItem.idType} value={typeItem.idType}>
                                {typeItem.designation}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* Sélection Client */}
                      <Grid item xs={12} md={3}>
                        <Autocomplete
                          id="idClient"
                          name="idClient"
                          options={filters}
                          getOptionLabel={(option) => option.nom || ''}
                          onChange={(e, value) => {
                            props.setFieldValue("idClient", value?.idClient || '');
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Nom Client"
                              variant="outlined"
                              fullWidth
                              error={props.errors.idClient && props.touched.idClient}
                              helperText={<ErrorMessage name="idClient" />}
                              disabled={loading}
                            />
                          )}
                        />
                      </Grid>

                      {/* Filtre Statut */}
                      <Grid item xs={12} md={2}>
                        <FormControl variant="outlined" className={classes.formControl} fullWidth>
                          <InputLabel>Statut</InputLabel>
                          <Select
                            label="Statut"
                            value={sort}
                            onChange={handleStatut}
                            disabled={loading || !props.values.idClient}
                          >
                            <MenuItem value="NON_PAYER">NON PAYÉ</MenuItem>
                            <MenuItem value="PAYER">PAYÉ</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* Filtres Date */}
                      <Grid item xs={12} md={3}>
                        <Box className={classes.dateFilterContainer}>
                          <TextField
                            label="Date début"
                            type="date"
                            value={dateFilter.startDate}
                            onChange={(e) => setDateFilter(prev => ({...prev, startDate: e.target.value}))}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                          <TextField
                            label="Date fin"
                            type="date"
                            value={dateFilter.endDate}
                            onChange={(e) => setDateFilter(prev => ({...prev, endDate: e.target.value}))}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                          {(dateFilter.startDate || dateFilter.endDate) && (
                            <Button 
                              variant="outlined" 
                              color="secondary" 
                              onClick={resetDateFilter}
                              size="small"
                              style={{ minWidth: 'auto' }}
                            >
                              Reset
                            </Button>
                          )}
                        </Box>
                      </Grid>

                      {/* Bouton Valider */}
                      <Grid item xs={12} md={1}>
                        <Button
                          type="submit"
                          className={classes.searchButton}
                          variant="contained"
                          fullWidth
                          disabled={loading || !props.values.idClient}
                          startIcon={loading ? <CircularProgress size={20} /> : <Search />}
                        >
                          {loading ? '...' : 'OK'}
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </CardContent>
          </Card>
        )}

        {/* Recherche par Période */}
        {searchMode === 'period' && (
          <Card className={classes.filterCard}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <DateRange style={{ marginRight: 8, color: '#226D68' }} />
                <Typography variant="h5" style={{ color: '#226D68', fontWeight: 600 }}>
                  Recherche par Période
                </Typography>
              </Box>

              <Grid container spacing={3} alignItems="center">
                {/* Dates de la période */}
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Date début"
                    type="date"
                    value={periodSearch.startDate}
                    onChange={(e) => setPeriodSearch(prev => ({
                      ...prev, 
                      startDate: e.target.value
                    }))}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    label="Date fin"
                    type="date"
                    value={periodSearch.endDate}
                    onChange={(e) => setPeriodSearch(prev => ({
                      ...prev, 
                      endDate: e.target.value
                    }))}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>

                {/* Type Client */}
                <Grid item xs={12} md={2}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Type Client</InputLabel>
                    <Select
                      label="Type Client"
                      onChange={handleFilters}
                      disabled={loading}
                    >
                      <MenuItem value="">
                        <em>Tous les types</em>
                      </MenuItem>
                      {type.map((typeItem) => (
                        <MenuItem key={typeItem.idType} value={typeItem.idType}>
                          {typeItem.designation}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Client (optionnel) */}
                <Grid item xs={12} md={2}>
                  <Autocomplete
                    id="periodClient"
                    options={filters}
                    getOptionLabel={(option) => option.nom || ''}
                    onChange={(e, value) => {
                      setPeriodSearch(prev => ({
                        ...prev, 
                        idClient: value?.idClient || ''
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Client (optionnel)"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                {/* Statut (optionnel) */}
                <Grid item xs={12} md={1}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Statut</InputLabel>
                    <Select
                      label="Statut"
                      value={periodSearch.statut}
                      onChange={(e) => setPeriodSearch(prev => ({
                        ...prev, 
                        statut: e.target.value
                      }))}
                    >
                      <MenuItem value="">Tous</MenuItem>
                      <MenuItem value="NON_PAYER">Non Payé</MenuItem>
                      <MenuItem value="PAYER">Payé</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Bouton Recherche */}
                <Grid item xs={12} md={1}>
                  <Button
                    className={classes.searchButton}
                    variant="contained"
                    fullWidth
                    onClick={handlePeriodSearch}
                    disabled={loading || !periodSearch.startDate || !periodSearch.endDate}
                    startIcon={loading ? <CircularProgress size={20} /> : <Search />}
                  >
                    {loading ? '...' : 'OK'}
                  </Button>
                </Grid>
              </Grid>

              {/* Information sur la période recherchée */}
              {(periodSearch.startDate || periodSearch.endDate) && (
                <Box className={classes.periodSearchInfo} mt={2}>
                  <Typography variant="body2">
                    <strong>Période recherchée :</strong> 
                    {periodSearch.startDate && ` Du ${new Date(periodSearch.startDate).toLocaleDateString('fr-FR')}`}
                    {periodSearch.endDate && ` Au ${new Date(periodSearch.endDate).toLocaleDateString('fr-FR')}`}
                    {periodSearch.idClient && ` | Client: ${filters.find(c => c.idClient === periodSearch.idClient)?.nom}`}
                    {periodSearch.statut && ` | Statut: ${periodSearch.statut === 'NON_PAYER' ? 'Non Payé' : 'Payé'}`}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        )}

        {/* Statistiques avec client sélectionné */}
        {filteredData.length > 0 && selectedClient && (
          <Card className={classes.statsCard}>
            <CardContent>
              {/* Section 1: Informations du client */}
              <Box className={classes.infoContainer}>
                <Chip
                  icon={<Person style={{ color: 'white' }} />}
                  label={`Client: ${selectedClient.nom}`}
                  className={`${classes.statChip} client`}
                  style={{ 
                    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                    color: 'white'
                  }}
                />
                <Chip
                  icon={<LocationOn style={{ color: 'white' }} />}
                  label={`Adresse: ${selectedClient.adresse || 'Non renseignée'}`}
                  className={`${classes.statChip} client`}
                  style={{ 
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white'
                  }}
                />
                {selectedClient.designation && (
                  <Chip
                    label={`Type: ${selectedClient.designation}`}
                    className={`${classes.statChip} client`}
                    style={{ 
                      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                      color: 'white'
                    }}
                  />
                )}
                
                {/* Statistiques globales */}
                <Chip
                  icon={<ShoppingCart style={{ color: 'white' }} />}
                  label={`${filteredData.length} ${filteredData.length === 1 ? 'vente' : 'ventes'}`}
                  className={`${classes.statChip} total`}
                />
                <Chip
                  icon={<AttachMoney style={{ color: 'white' }} />}
                  label={`${totalAmount.toLocaleString()} Fcfa`}
                  className={`${classes.statChip} amount`}
                />
                
                {/* Statistiques IPM */}
                {isIPMType && (
                  <>
                    <Chip
                      icon={<TrendingUp style={{ color: 'white' }} />}
                      label={`Part Client: ${totalClient.toLocaleString()} Fcfa`}
                      className={`${classes.statChip} client`}
                    />
                    <Chip
                      icon={<TrendingUp style={{ color: 'white' }} />}
                      label={`Part IPM: ${totalIpm.toLocaleString()} Fcfa`}
                      className={`${classes.statChip} ipm`}
                    />
                  </>
                )}
                
                {/* Boutons d'action */}
                {selectedRows.length > 0 && (
                  <Button
                    className={classes.exportButton}
                    variant="contained"
                    onClick={handleMultiplePDF}
                    startIcon={<PictureAsPdf />}
                    size="small"
                  >
                    PDF ({selectedRows.length})
                  </Button>
                )}

                {/* Bouton Payer tout */}
                {searchMode === 'client' && filteredData.length > 0 && sort === 'NON_PAYER' && (
                  <CustomizedDialogs title="Payer tout" boutonTitle="Payer tout" refresh={refreshBons}>
                    <PayementForm bons={filteredData} />
                  </CustomizedDialogs>
                )}

                {/* Bouton Export PDF */}
                {searchMode === 'client' && <Button
                  className={classes.exportButton}
                  variant="contained"
                  disabled={filteredData.length === 0 || loading}
                  onClick={handleExportPDF}
                  startIcon={<GetApp />}
                  size="small"
                >
                  Tout exporter
                </Button>}

                {/* Bouton Réinitialiser */}
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={resetSearch}
                  size="small"
                >
                  Réinitialiser
                </Button>
              </Box>

              {/* Section 2: Informations SOLDE et TVA */}
              {sort === 'NON_PAYER' && selectedClient && (
                <Box mt={2} p={2} style={{ 
                  background: '#f8f9fa', 
                  borderRadius: '8px',
                  border: '1px solid #dee2e6'
                }}>
                  <Typography variant="h6" gutterBottom style={{ color: '#226D68', fontWeight: 'bold' }}>
                    Informations Financières du Client
                  </Typography>
                  
                  <Grid container spacing={2}>
                    {/* Colonne 1: Informations solde */}
                    <Grid item xs={12} md={4}>
                      <Box p={2} style={{ 
                        background: 'white', 
                        borderRadius: '6px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Typography variant="subtitle2" style={{ color: '#6c757d', marginBottom: '8px' }}>
                          <strong>SOLDE ET QUOTA</strong>
                          <Button 
                            size="small" 
                            onClick={refreshClientInfo}
                            style={{ marginLeft: '10px', fontSize: '10px', padding: '2px 6px' }}
                          >
                            🔄
                          </Button>
                        </Typography>

                        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '8px', fontSize: '14px' }}>
                          <span>Solde actuel:</span>
                          <span style={{ textAlign: 'right', fontWeight: 'bold', color: '#28a745' }}>
                            {selectedClient?.solde?.toLocaleString() || '0'} Fcfa
                          </span>
                          
                          <span>Quota autorisé:</span>
                          <span style={{ textAlign: 'right', color: '#6c757d' }}>
                            {selectedClient?.quota?.toLocaleString() || '0'} Fcfa
                          </span>
                          
                          {selectedClient?.quota > 0 && (
                            <>
                              <span style={{ paddingTop: '8px', borderTop: '1px solid #dee2e6' }}>
                                Solde disponible:
                              </span>
                              <span style={{ 
                                textAlign: 'right', 
                                paddingTop: '8px', 
                                borderTop: '1px solid #dee2e6',
                                fontWeight: 'bold',
                                color: (selectedClient.quota - selectedClient.solde) > 0 ? '#28a745' : '#dc3545'
                              }}>
                                {((selectedClient.quota || 0) - (selectedClient.solde || 0)).toLocaleString()} Fcfa
                              </span>
                            </>
                          )}
                        </div>
                      </Box>
                    </Grid>
                    
                    {/* Colonne 2: Calculs TVA */}
                    <Grid item xs={12} md={4}>
                      <Box p={2} style={{ 
                        background: 'white', 
                        borderRadius: '6px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Typography variant="subtitle2" style={{ color: '#6c757d', marginBottom: '8px' }}>
                          <strong>CALCULS TVA</strong>
                        </Typography>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '8px', fontSize: '14px' }}>
                          <span>Total sans TVA:</span>
                          <span style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {totalAmount.toLocaleString()} Fcfa
                          </span>
                          
                          <span>TVA 1% (espèces):</span>
                          <span style={{ textAlign: 'right', color: '#28a745' }}>
                            {(totalAmount * 0.01).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                          </span>
                          
                          <span>TVA 0.5% (mobile):</span>
                          <span style={{ textAlign: 'right', color: '#17a2b8' }}>
                            {(totalAmount * 0.005).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                          </span>
                          
                          <span style={{ paddingTop: '8px', borderTop: '1px solid #dee2e6', fontWeight: 'bold' }}>
                            Total avec TVA 1%:
                          </span>
                          <span style={{ 
                            textAlign: 'right', 
                            paddingTop: '8px', 
                            borderTop: '1px solid #dee2e6',
                            fontWeight: 'bold',
                            color: '#e65100'
                          }}>
                            {(totalAmount * 1.01).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                          </span>
                        </div>
                      </Box>
                    </Grid>
                    
                    {/* Colonne 3: Vérification quota */}
                    <Grid item xs={12} md={4}>
                      <Box p={2} style={{ 
                        background: 'white', 
                        borderRadius: '6px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Typography variant="subtitle2" style={{ color: '#6c757d', marginBottom: '8px' }}>
                          <strong>VÉRIFICATION QUOTA</strong>
                        </Typography>
                        
                        {selectedClient.quota > 0 ? (
                          <>
                            {/* Calcul pour espèce (TVA 1%) */}
                            <div style={{ marginBottom: '12px' }}>
                              <Typography variant="caption" style={{ color: '#6c757d', display: 'block' }}>
                                Paiement espèces (TVA 1%):
                              </Typography>
                              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '4px', fontSize: '13px' }}>
                                <span>Total TTC:</span>
                                <span style={{ textAlign: 'right' }}>
                                  {(totalAmount * 1.01).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                                </span>
                                <span>Solde après paiement:</span>
                                <span style={{ 
                                  textAlign: 'right', 
                                  fontWeight: 'bold',
                                  color: selectedClient.solde - (totalAmount * 1.01) >= 0 ? '#28a745' : '#dc3545'
                                }}>
                                  {(selectedClient.solde - (totalAmount * 1.01)).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                                </span>
                              </div>
                              {(selectedClient.solde - (totalAmount * 1.01)) < 0 && (
                                <Typography variant="caption" style={{ color: '#dc3545', display: 'block', marginTop: '4px' }}>
                                  ❌ Dépassement: {Math.abs(selectedClient.solde - (totalAmount * 1.01)).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                                </Typography>
                              )}
                            </div>
                            
                            {/* Calcul pour mobile (TVA 0.5%) */}
                            <div>
                              <Typography variant="caption" style={{ color: '#6c757d', display: 'block' }}>
                                Paiement mobile (TVA 0.5%):
                              </Typography>
                              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '4px', fontSize: '13px' }}>
                                <span>Total TTC:</span>
                                <span style={{ textAlign: 'right' }}>
                                  {(totalAmount * 1.005).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                                </span>
                                <span>Solde après paiement:</span>
                                <span style={{ 
                                  textAlign: 'right', 
                                  fontWeight: 'bold',
                                  color: selectedClient.solde - (totalAmount * 1.005) >= 0 ? '#28a745' : '#dc3545'
                                }}>
                                  {(selectedClient.solde - (totalAmount * 1.005)).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                                </span>
                              </div>
                              {(selectedClient.solde - (totalAmount * 1.005)) < 0 && (
                                <Typography variant="caption" style={{ color: '#dc3545', display: 'block', marginTop: '4px' }}>
                                  ❌ Dépassement: {Math.abs(selectedClient.solde - (totalAmount * 1.005)).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                                </Typography>
                              )}
                            </div>
                          </>
                        ) : (
                          <Typography variant="body2" style={{ color: '#6c757d', textAlign: 'center', padding: '10px' }}>
                            Pas de quota défini pour ce client
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Indicateur de filtre date actif */}
              {(dateFilter.startDate || dateFilter.endDate) && (
                <Box mt={1}>
                  <Typography variant="body2" color="textSecondary">
                    Filtre date: 
                    {dateFilter.startDate && ` Du ${new Date(dateFilter.startDate).toLocaleDateString('fr-FR')}`}
                    {dateFilter.endDate && ` Au ${new Date(dateFilter.endDate).toLocaleDateString('fr-FR')}`}
                    {` (${filteredData.length} résultat(s))`}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        )}

        {/* Statistiques SANS client sélectionné */}
        {filteredData.length > 0 && !selectedClient && (
          <Card className={classes.statsCard}>
            <CardContent>
              <Box className={classes.infoContainer}>
                {/* Statistiques globales seulement */}
                <Chip
                  icon={<ShoppingCart style={{ color: 'white' }} />}
                  label={`${filteredData.length} ${filteredData.length === 1 ? 'vente' : 'ventes'}`}
                  className={`${classes.statChip} total`}
                />
                <Chip
                  icon={<AttachMoney style={{ color: 'white' }} />}
                  label={`${totalAmount.toLocaleString()} Fcfa`}
                  className={`${classes.statChip} amount`}
                />
                
                {/* Bouton PDF multiple */}
                {selectedRows.length > 0 && (
                  <Button
                    className={classes.exportButton}
                    variant="contained"
                    onClick={handleMultiplePDF}
                    startIcon={<PictureAsPdf />}
                    size="small"
                  >
                    PDF ({selectedRows.length})
                  </Button>
                )}

                {/* Bouton Export PDF */}
                <Button
                  className={classes.exportButton}
                  variant="contained"
                  disabled={filteredData.length === 0 || loading}
                  onClick={handleExportPDF}
                  startIcon={<GetApp />}
                  size="small"
                >
                  Tout exporter
                </Button>

                {/* Bouton Réinitialiser */}
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={resetSearch}
                  size="small"
                >
                  Réinitialiser
                </Button>
              </Box>

              {/* Calculs TVA généraux */}
              <Box mt={2} p={2} style={{ 
                background: '#f8f9fa', 
                borderRadius: '8px',
                border: '1px solid #dee2e6'
              }}>
                <Typography variant="subtitle1" gutterBottom style={{ color: '#226D68', fontWeight: 'bold' }}>
                  Résumé Financier
                </Typography>
                
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Box p={2} style={{ 
                      background: 'white', 
                      borderRadius: '6px',
                      border: '1px solid #e9ecef'
                    }}>
                      <Typography variant="subtitle2" style={{ color: '#6c757d', marginBottom: '8px' }}>
                        <strong>CALCULS TVA</strong>
                      </Typography>
                      
                      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '8px', fontSize: '14px' }}>
                        <span>Total HT:</span>
                        <span style={{ textAlign: 'right', fontWeight: 'bold' }}>
                          {totalAmount.toLocaleString()} Fcfa
                        </span>
                        
                        <span>TVA 1% (espèces):</span>
                        <span style={{ textAlign: 'right', color: '#28a745' }}>
                          {(totalAmount * 0.01).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                        </span>
                        
                        <span>TVA 0.5% (mobile):</span>
                        <span style={{ textAlign: 'right', color: '#17a2b8' }}>
                          {(totalAmount * 0.005).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                        </span>
                        
                        <span style={{ paddingTop: '8px', borderTop: '1px solid #dee2e6', fontWeight: 'bold' }}>
                          Total TTC 1%:
                        </span>
                        <span style={{ 
                          textAlign: 'right', 
                          paddingTop: '8px', 
                          borderTop: '1px solid #dee2e6',
                          fontWeight: 'bold',
                          color: '#e65100'
                        }}>
                          {(totalAmount * 1.01).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                        </span>
                        
                        <span style={{ fontWeight: 'bold' }}>Total TTC 0.5%:</span>
                        <span style={{ 
                          textAlign: 'right', 
                          fontWeight: 'bold',
                          color: '#ff5722'
                        }}>
                          {(totalAmount * 1.005).toLocaleString(undefined, {maximumFractionDigits:2})} Fcfa
                        </span>
                      </div>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Box p={2} style={{ 
                      background: 'white', 
                      borderRadius: '6px',
                      border: '1px solid #e9ecef'
                    }}>
                      <Typography variant="subtitle2" style={{ color: '#6c757d', marginBottom: '8px' }}>
                        <strong>INFORMATIONS</strong>
                      </Typography>
                      
                      <Typography variant="body2" style={{ color: '#6c757d', marginBottom: '12px' }}>
                        Mode de recherche: <strong>{searchMode === 'period' ? 'Par Période' : 'Par Client'}</strong>
                      </Typography>
                      
                      {searchMode === 'period' && periodSearch.startDate && periodSearch.endDate && (
                        <Typography variant="body2" style={{ color: '#6c757d', marginBottom: '12px' }}>
                          Période: <strong>
                            {new Date(periodSearch.startDate).toLocaleDateString('fr-FR')} 
                            {" "}à{" "}
                            {new Date(periodSearch.endDate).toLocaleDateString('fr-FR')}
                          </strong>
                        </Typography>
                      )}
                      
                      <Typography variant="body2" style={{ color: '#6c757d', fontStyle: 'italic' }}>
                        Note: Pour les informations de solde et quota, sélectionnez un client spécifique.
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* Indicateur de filtre date actif */}
              {(dateFilter.startDate || dateFilter.endDate) && (
                <Box mt={1}>
                  <Typography variant="body2" color="textSecondary">
                    Filtre date: 
                    {dateFilter.startDate && ` Du ${new Date(dateFilter.startDate).toLocaleDateString('fr-FR')}`}
                    {dateFilter.endDate && ` Au ${new Date(dateFilter.endDate).toLocaleDateString('fr-FR')}`}
                    {` (${filteredData.length} résultat(s))`}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        )}

        {/* Tableau des données moderne */}
        <Card className={classes.tableCard}>
          <CardContent style={{ padding: 0 }}>
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" height={400}>
                <CircularProgress size={40} style={{ color: '#226D68' }} />
              </Box>
            ) : filteredData.length > 0 ? (
              <>
                <TableContainer>
                  <Table className={classes.modernTable} size="medium">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                            checked={selectedRows.length === filteredData.length}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedRows(filteredData.map(row => row.idBon));
                              } else {
                                setSelectedRows([]);
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Box display="flex" alignItems="center">
                            <PersonOutline fontSize="small" style={{ marginRight: 8 }} />
                            Bénéficiaire
                          </Box>
                        </TableCell>
                        <TableCell>Produit</TableCell>
                        <TableCell align="center">Qté</TableCell>
                        <TableCell align="right">Prix Unitaire</TableCell>
                        <TableCell align="right">HT</TableCell>
                        <TableCell align="right">TVA</TableCell>
                        <TableCell align="right">TTC</TableCell>
                        <TableCell align="center">Taux TVA</TableCell>
                        <TableCell>
                          <Box display="flex" alignItems="center">
                            <CalendarToday fontSize="small" style={{ marginRight: 8 }} />
                            Date Création
                          </Box>
                        </TableCell>
                        <TableCell align="center">Statut</TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedData.map((row) => {
                        const isSelected = selectedRows.includes(row.idBon);
                        const ht = row.prix_sans_tva || row.total || 0;
                        const tva = row.tva_montant || 0;
                        const ttc = row.prix_avec_tva || row.total || 0;
                        const tauxTVA = row.tva_taux || 0;

                        return (
                          <TableRow 
                            key={row.idBon} 
                            hover
                            selected={isSelected}
                            className={isSelected ? 'selected-row' : ''}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isSelected}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedRows([...selectedRows, row.idBon]);
                                  } else {
                                    setSelectedRows(selectedRows.filter(id => id !== row.idBon));
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <Box display="flex" alignItems="center">
                                <Avatar className={classes.clientAvatar}>
                                  {row.beneficiaire?.charAt(0) || 'C'}
                                </Avatar>
                                <Box ml={2}>
                                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                                    {row.beneficiaire || 'Non spécifié'}
                                  </Typography>
                                  <Typography variant="caption" color="textSecondary">
                                    {row.nomProd || 'Produit'}
                                  </Typography>
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {row.nomProd || 'N/A'}
                              </Typography>
                              <Typography variant="caption" color="textSecondary">
                                Réf: {row.codeIdProd || 'N/A'}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Chip 
                                label={row.qtVdu || 0} 
                                size="small" 
                                variant="outlined"
                                style={{ fontWeight: 600 }}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" style={{ fontWeight: 500 }}>
                                {(row.prixProdVendu || 0).toLocaleString()} Fcfa
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" className={`${classes.amountCell} ht`}>
                                {ht.toLocaleString()} Fcfa
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              {tva > 0 ? (
                                <Typography variant="body2" className={`${classes.amountCell} tva`}>
                                  {tva.toLocaleString()} Fcfa
                                </Typography>
                              ) : (
                                <Typography variant="body2" color="textSecondary">
                                  -
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" className={`${classes.amountCell} ttc`}>
                                {ttc.toLocaleString()} Fcfa
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              {tauxTVA > 0 ? (
                                <Box display="flex" alignItems="center" justifyContent="center">
                                  {getPaymentIcon(tauxTVA)}
                                  <Typography 
                                    variant="caption" 
                                    style={{ 
                                      marginLeft: 4,
                                      color: tauxTVA === 0.01 ? '#28a745' : tauxTVA === 0.005 ? '#17a2b8' : '#6c757d',
                                      fontWeight: 600 
                                    }}
                                  >
                                    {(tauxTVA * 100).toFixed(1)}%
                                  </Typography>
                                </Box>
                              ) : (
                                <Chip
                                  label="Sans TVA"
                                  size="small"
                                  style={{
                                    backgroundColor: 'rgba(108, 117, 125, 0.1)',
                                    color: '#6c757d',
                                    border: '1px solid rgba(108, 117, 125, 0.3)',
                                    fontSize: '0.75rem',
                                    fontWeight: 600
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              <Box className={classes.dateCell}>
                                <CalendarToday fontSize="small" />
                                <Typography variant="body2">
                                  {row.dateEnreg ? new Date(row.dateEnreg).toLocaleDateString('fr-FR') : 'N/A'}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Badge
                                variant="dot"
                                color={row.statut === 'PAYER' ? 'primary' : 'secondary'}
                              >
                                <Chip
                                  label={row.statut === 'PAYER' ? 'PAYÉ' : 'NON PAYÉ'}
                                  size="small"
                                  style={{
                                    backgroundColor: row.statut === 'PAYER' ? 'rgba(40, 167, 69, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                                    color: row.statut === 'PAYER' ? '#28a745' : '#dc3545',
                                    border: `1px solid ${row.statut === 'PAYER' ? 'rgba(40, 167, 69, 0.3)' : 'rgba(220, 53, 69, 0.3)'}`,
                                    fontWeight: 600
                                  }}
                                />
                              </Badge>
                            </TableCell>
                            <TableCell align="center">
                              <Box display="flex" justifyContent="center">
                                {row.statut === 'NON_PAYER' && (
                                  <CustomizedDialogs title="Payer" boutonTitle="Payer" refresh={refreshBons}>
                                    <PayeBon idBon={row.idBon} />
                                  </CustomizedDialogs>
                                )}
                                
                                {searchMode === 'client' && row.statut === 'PAYER' && (
                                  <>
                                    <Tooltip title="Générer PDF">
                                      <IconButton 
                                        size="small" 
                                        className={`${classes.actionButton} pdf-button`}
                                        onClick={() => handleSinglePDF(row)}
                                      >
                                        <PictureAsPdf fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    
                                    <Tooltip title="Supprimer">
                                      <IconButton 
                                        size="small" 
                                        className={`${classes.actionButton} delete-button`}
                                        onClick={() => handleDelete(row)}
                                      >
                                        <DeleteOutlined fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={filteredData.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  labelRowsPerPage="Lignes par page"
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
                />
              </>
            ) : (
              <Box textAlign="center" py={4}>
                {searchMode === 'client' ? (
                  <>
                    <SearchOutlined style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }} />
                    <Typography variant="h6" color="textSecondary" gutterBottom>
                      Aucun bon client trouvé
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Sélectionnez un client pour afficher ses bons
                    </Typography>
                  </>
                ) : (
                  <>
                    <DateRange style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }} />
                    <Typography variant="h6" color="textSecondary" gutterBottom>
                      Aucun résultat pour cette période
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Définissez une période de recherche
                    </Typography>
                  </>
                )}
              </Box>
            )}
          </CardContent>
        </Card>
      </Container>
    </div>
  );
};

export default ListBonClient;